import React, { useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Hero from "components/hero/Hero";
import BusinessOverView from "components/cards/BusinessOverView";
import Footer from "components/footers/FiveColumnDark";
import SystemEngineering from "components/features/SystemEngineering";
import ReinforcementSystem from "components/hero/ReinforcementSystem";
import DecoratorBlobDesign from "components/cards/DecoratorBlobDesign";
import LeaseBusiness from "components/hero/LeaseBusiness";
import ChineseMarket from "components/hero/ChineseMarket";
import GlobalStyle from "helpers/GlobalStyle";
import SplashAnimationContainer from "helpers/SplashAnimationContainer";
import useScreenSize from "helpers/useScreenSize";

const BgWrapper = styled.div`
  ${({ isXs }) => !isXs && tw`fancy-feature-mask`}
`;

export default () => {
  const { isXs } = useScreenSize();
  const businessIntroRef = useRef();
  const systemEngRef = useRef();
  const reinforcementRef = useRef();
  const leaseRef = useRef();
  const chineseMarketRef = useRef();

  return (
    <div style={{ marginTop: "50px" }}>
      <GlobalStyle />
      <Hero isXs={isXs} />
      <SplashAnimationContainer>
        <BgWrapper isXs={isXs}>
          <BusinessOverView
            isXs={isXs}
            businessIntroRef={businessIntroRef}
            systemEngRef={systemEngRef}
            reinforcementRef={reinforcementRef}
            leaseRef={leaseRef}
            chineseMarketRef={chineseMarketRef}
          />
        </BgWrapper>
        <DecoratorBlobDesign />
        <div className={!isXs ? "gradient-container" : ""}>
          <div ref={systemEngRef}>
            <SystemEngineering isXs={isXs} />
          </div>
        </div>

        <DecoratorBlobDesign />
        <div ref={reinforcementRef}>
          <ReinforcementSystem isXs={isXs} />
        </div>

        <DecoratorBlobDesign />

        <div className={!isXs ? "gradient-container" : ""}>
          <div ref={leaseRef}>
            <LeaseBusiness isXs={isXs} />
          </div>
        </div>

        <DecoratorBlobDesign />
        <BgWrapper isXs={isXs}>
          <div ref={chineseMarketRef}>
            <ChineseMarket  isXs={isXs}/>
          </div>
        </BgWrapper>
        <Footer isXs={isXs} />
      </SplashAnimationContainer>
    </div>
  );
};
